import { render } from "./CustomerForgotPassword.vue?vue&type=template&id=5ef23014&scoped=true"
import script from "./CustomerForgotPassword.vue?vue&type=script&lang=js"
export * from "./CustomerForgotPassword.vue?vue&type=script&lang=js"

import "./CustomerForgotPassword.vue?vue&type=style&index=0&id=5ef23014&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef23014"]])

export default __exports__